module.exports = __webpack_public_path__ + "img/razzo-head-page-1.88bbb26e.webp";